export default __webpack_public_path__ + "assets/images/pricing/6fe56866c5b3bb51925ec0cbfc5a9dba.png";